import { strings } from "../strings"

const HistoryDetail = ({ booking }) => {

    const startDate = new Date(booking.start)
    const month = startDate.getMonth() + 1
    const end = new Date(startDate.getTime() + 90*60000);
    const startMinutes = ('0'+ startDate.getMinutes()).slice(-2)
    const endMinutes = ('0'+ end.getMinutes()).slice(-2)
    const formattedTimeString = startDate.getDate() + "/" + month + " " + startDate.getHours() + ":" + startMinutes + " - " + end.getHours() + ":" + endMinutes
    const machines = booking.machineID === 1 ? strings.laundry.machine1 : booking.machineID === 2 ? strings.laundry.machine2 : strings.laundry.bothMachines

    return (
        <div className="booking-details" style={{ margin: "1vh", padding: "1vh"}}>
            <h4 style={{color: "#cccccc"}}>{booking.facility}</h4>
            {booking.facility !== strings.balcony.balcony && <p style={{color: "#cccccc"}}>{machines}</p>}
            <p style={{color: "#cccccc"}}>{formattedTimeString}</p>
        </div>
    )
}

export default HistoryDetail